import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const stockApi = {
  screener: (params) => api.get('/stocks/screener', { params }),
  search: (q) => api.get('/stocks/search', { params: { q } }),
  getStock: (symbol) => api.get(`/stocks/${symbol}`),
};

export const portfolioApi = {
  get: () => api.get('/portfolio'),
  addHolding: (holding) => api.post('/portfolio/holdings', holding),
};

export const watchlistApi = {
  getAll: () => api.get('/watchlists'),
  create: (watchlist) => api.post('/watchlists', watchlist),
};

export const aiApi = {
  generateTradeIdeas: (data) => api.post('/ai/trade-ideas', data),
};

export const newsApi = {
  get: () => api.get('/news'),
};

export const externalApi = {
  chartinkScans: () => api.get('/external/chartink/scans'),
  chartinkRun: (scanKey) => api.get(`/external/chartink/scan/${scanKey}`),
  screener: (symbol) => api.get(`/external/screener/${symbol}`),
  tradingview: (symbol, exchange = 'NSE') => api.get(`/external/tradingview/${symbol}`, { params: { exchange } }),
  options: (symbol) => api.get(`/external/options/${symbol}`),
};

export const liveApi = {
  nseIndices: () => api.get('/live/nse/indices'),
  nseMarketStatus: () => api.get('/live/nse/market-status'),
  nseGainers: () => api.get('/live/nse/gainers'),
  nseLosers: () => api.get('/live/nse/losers'),
  nseFiiDii: () => api.get('/live/nse/fii-dii'),
  bseQuote: (symbol) => api.get(`/live/bse/quote/${symbol}`),
  bseCorpActions: () => api.get('/live/bse/corporate-actions'),
  bseScrips: () => api.get('/live/bse/scrips'),
};

export const backtestApi = {
  strategies: () => api.get('/backtest/strategies'),
  run: (payload) => api.post('/backtest/run', payload),
  runNifty50: (payload) => api.post('/backtest/nifty50', payload),
  aiSuggest: (payload) => api.post('/backtest/ai-suggest', payload),
};

export const paperApi = {
  account: () => api.get('/paper/account'),
  order: (payload) => api.post('/paper/order', payload),
  trades: () => api.get('/paper/trades'),
  reset: () => api.post('/paper/reset'),
};

export const alertsApi = {
  list: () => api.get('/alerts'),
  create: (payload) => api.post('/alerts', payload),
  toggle: (id, active) => api.patch(`/alerts/${id}`, { active }),
  remove: (id) => api.delete(`/alerts/${id}`),
};

export const notificationsApi = {
  list: (unreadOnly = false) => api.get('/notifications', { params: { unread_only: unreadOnly } }),
  markRead: (id) => api.post(`/notifications/${id}/read`),
  markAllRead: () => api.post('/notifications/read-all'),
};

export default api;